import { gql } from "lib/apolloClient";
import { plannerElementNodeSetFragment } from "./AssessmentLearningGoalsFragments";

// Query to fetch planner element node set IDs from curriculum
export const getPlannerElementNodeSetIdsOfCurriculumQuery = gql`
  query getPlannerElementNodeSetIdsOfCurriculum(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $plannerElementNodeSetFilters: PlannerElementNodeSetFilters
  ) {
    node(id: $id, type: $type) {
      id
      ... on IbMypCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
        }
      }
      ... on UBDCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
        }
      }
      ... on IbDpCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
        }
      }
      ... on IbPypCurriculumProgram {
        id
        plannerElementNodeSets(filters: $plannerElementNodeSetFilters) {
          ...plannerElementNodeSetItem
        }
      }
    }
  }
  ${plannerElementNodeSetFragment.plannerElementNodeSet}
`;

// Query to fetch planner element node sets with full node data from IDs
export const getPlannerElementNodeSetsFromIdsQuery = gql`
  query getPlannerElementNodeSetsFromIds(
    $plannerElementNodeSetIds: [ID!]
    $plannerElementNodeFilters: PlannerElementNodeFilters
  ) {
    multiNode(ids: $plannerElementNodeSetIds, type: PLANNER_ELEMENT_NODE_SET) {
      ... on PlannerElementNodeSet {
        ...plannerElementNodeSetWithNodesItem
      }
    }
  }
  ${plannerElementNodeSetFragment.plannerElementNodeSetWithNodes}
`;
